export const navSections = [
  { id: "categories", label: "内容板块" },
  { id: "movies", label: "影视精选" },
  { id: "library", label: "在线检索" },
  { id: "novels", label: "小说漫画" },
  { id: "audio", label: "听书资源" },
  { id: "ranking", label: "热门榜单" },
  { id: "adfree", label: "无广告版" },
  { id: "faq", label: "常见问题" },
];

export const heroStats = [
  { value: "12.6万+", label: "在库影视剧集" },
  { value: "48万+", label: "免费小说与漫画" },
  { value: "9.3万+", label: "听书音频专辑" },
  { value: "每日", label: "持续更新资源" },
];

export const heroQuickTags = ["高清影视", "免费小说", "漫画连载", "听书音频", "无广告版"];

export const categories = [
  {
    id: "movie",
    icon: "ri-film-line",
    name: "中文在线高清影视",
    tagline: "字幕齐全 · 多线路切换",
    desc: "院线新片、口碑剧集、经典老片分区整理，提供中文字幕与多清晰度选择，通勤或睡前都能随手点开。",
    points: ["中文字幕同步更新", "1080P 高清画质", "剧情 / 悬疑 / 科幻分区"],
    count: "12.6万+ 部",
  },
  {
    id: "novel",
    icon: "ri-book-2-line",
    name: "中文在线字幕免费小说",
    tagline: "书名即搜 · 排版舒适",
    desc: "玄幻、都市、悬疑、言情等长篇与短篇分类齐全，阅读页支持字号与背景调节，长时间阅读也不累眼。",
    points: ["连载与完结分类", "护眼阅读模式", "书架进度本地记录"],
    count: "32万+ 本",
  },
  {
    id: "comic",
    icon: "ri-image-2-line",
    name: "中文在线漫画免费看",
    tagline: "条漫竖屏 · 逐话更新",
    desc: "国产漫画、日漫条漫、绘本短篇均可直接翻页浏览，竖屏滚动适配手机阅读，热门作品紧跟更新进度。",
    points: ["竖屏条漫适配", "逐话连贯翻页", "画风标签筛选"],
    count: "16万+ 话",
  },
  {
    id: "audio",
    icon: "ri-headphone-line",
    name: "中文在线听书资源",
    tagline: "真人播讲 · 连贯听感",
    desc: "有声小说、评书、睡前故事与知识讲解频道，支持后台播放与定时关闭，做家务、通勤时都能安心收听。",
    points: ["后台连续播放", "定时关闭功能", "音色风格任选"],
    count: "9.3万+ 专辑",
  },
];

export const movieGenres = ["全部", "剧情", "悬疑", "科幻", "古装", "动画", "喜剧"];

export const movies = [
  {
    id: "m1",
    title: "夜航西飞",
    genre: "剧情",
    year: "2024",
    episode: "电影 · 118 分钟",
    rating: "8.7",
    desc: "一名女飞行员独自跨越夜海，在风暴与孤独中重新审视自己与家人的关系，镜头诗意而克制。",
    tag: "口碑首选",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20art%20of%20a%20lone%20airplane%20flying%20over%20a%20dark%20ocean%20at%20night%2C%20deep%20amber%20and%20teal%20color%20grading%2C%20dramatic%20lighting%2C%20grainy%20film%20texture%2C%20moody%20atmosphere%2C%20no%20text&width=600&height=900&seq=movie-night-flight-01&orientation=portrait",
  },
  {
    id: "m2",
    title: "长风渡海",
    genre: "古装",
    year: "2023",
    episode: "全 42 集",
    rating: "8.4",
    desc: "少年船工卷入漕运迷局，一路结识异士、破局护船，勾勒出一幅热闹又惊险的东方江湖长卷。",
    tag: "热播更新",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20art%20of%20ancient%20chinese%20harbour%20with%20sailing%20ships%20in%20morning%20mist%2C%20warm%20golden%20and%20jade%20green%20tones%2C%20epic%20period%20drama%20lighting%2C%20textured%20brush%20grain%2C%20no%20text&width=600&height=900&seq=movie-long-wind-02&orientation=portrait",
  },
  {
    id: "m3",
    title: "回声之城",
    genre: "科幻",
    year: "2024",
    episode: "全 24 集",
    rating: "8.9",
    desc: "在一座会不断重置记忆的城市里，三名陌生人试图拼出真相，冷峻的设定下藏着温柔的追问。",
    tag: "高分推荐",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20film%20poster%20art%20of%20a%20futuristic%20city%20reflected%20in%20endless%20echoing%20glass%20corridors%2C%20teal%20and%20amber%20neon%20highlights%2C%20volumetric%20fog%2C%20moody%20atmosphere%2C%20no%20text&width=600&height=900&seq=movie-echo-city-03&orientation=portrait",
  },
  {
    id: "m4",
    title: "第七次日落",
    genre: "剧情",
    year: "2022",
    episode: "电影 · 104 分钟",
    rating: "8.1",
    desc: "小镇摄影师用一个夏天记录七次日落，也记录下与母亲和解的每个瞬间，细腻而克制。",
    tag: "温暖治愈",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20art%20of%20a%20quiet%20countryside%20sunset%20over%20wheat%20fields%2C%20warm%20orange%20and%20golden%20grading%2C%20soft%20lens%20flare%2C%20nostalgic%20film%20grain%2C%20no%20text&width=600&height=900&seq=movie-sunset-04&orientation=portrait",
  },
  {
    id: "m5",
    title: "山海奇谈",
    genre: "动画",
    year: "2024",
    episode: "全 16 集",
    rating: "8.6",
    desc: "取材上古异兽的国风动画，每一集讲述一段山海之间的相遇，水墨与三维结合的画面极具观赏性。",
    tag: "国风动画",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20animation%20poster%20art%20of%20mythical%20chinese%20beasts%20in%20misty%20mountains%2C%20ink%20wash%20style%20with%20gold%20and%20jade%20accents%2C%20dreamlike%20atmosphere%2C%20painterly%20texture%2C%20no%20text&width=600&height=900&seq=movie-myth-05&orientation=portrait",
  },
  {
    id: "m6",
    title: "暗涌",
    genre: "悬疑",
    year: "2023",
    episode: "全 30 集",
    rating: "8.5",
    desc: "一桩沉寂多年的旧案重新浮上水面，刑警与记者联手追查，节奏紧凑、反转不断。",
    tag: "悬疑烧脑",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20thriller%20film%20poster%20art%20of%20rainy%20night%20city%20street%20with%20long%20shadows%2C%20dark%20teal%20and%20dull%20amber%20lighting%2C%20tense%20moody%20atmosphere%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=movie-undercurrent-06&orientation=portrait",
  },
  {
    id: "m7",
    title: "无声告白",
    genre: "剧情",
    year: "2024",
    episode: "电影 · 96 分钟",
    rating: "8.3",
    desc: "聋哑女孩与父亲相依为命，用手语和字幕讲述一段不被听见却格外响亮的成长故事。",
    tag: "现实题材",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20film%20poster%20art%20of%20a%20quiet%20window%20with%20soft%20afternoon%20light%20and%20sheer%20curtains%2C%20gentle%20cream%20and%20rose%20tones%2C%20intimate%20mood%2C%20subtle%20grain%2C%20no%20text&width=600&height=900&seq=movie-silent-07&orientation=portrait",
  },
  {
    id: "m8",
    title: "光年之外",
    genre: "科幻",
    year: "2022",
    episode: "全 20 集",
    rating: "8.0",
    desc: "星际信号员与地球上的恋人相隔光年，用延迟的语音留言维系感情，浪漫又略带怅惘。",
    tag: "科幻爱情",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20romance%20film%20poster%20art%20of%20a%20lone%20space%20station%20window%20facing%20a%20distant%20warm%20planet%2C%20amber%20and%20deep%20teal%20palette%2C%20starry%20backdrop%2C%20no%20text&width=600&height=900&seq=movie-lightyear-08&orientation=portrait",
  },
];

export const novels = [
  { id: "n1", title: "九州云荒录", genre: "玄幻", status: "连载中", author: "慕长歌", heat: "128万", intro: "少年自云荒边地走出，凭一部残卷踏遍九州，在宗门与家国之间寻找自己的道。" },
  { id: "n2", title: "长夜将明", genre: "悬疑", status: "已完结", author: "沈默言", heat: "96万", intro: "旧城连环案重启，法医与刑警在层层迷雾中抽丝剥茧，真相远比想象更沉重。" },
  { id: "n3", title: "簪花录", genre: "古言", status: "连载中", author: "苏挽月", heat: "87万", intro: "工匠之女凭一手簪花绝技入宫，在深宫与匠人之间守住初心，步步生花。" },
  { id: "n4", title: "星轨之下", genre: "科幻", status: "已完结", author: "陆离", heat: "79万", intro: "星际移民时代，一名导航员发现航线背后被隐藏的秘密，决定逆轨而行。" },
  { id: "n5", title: "青衫误", genre: "都市", status: "连载中", author: "江照野", heat: "73万", intro: "错发的一条消息，让两个本无交集的都市人开始了一段认真又笨拙的靠近。" },
  { id: "n6", title: "雾中灯塔", genre: "现实", status: "已完结", author: "林之隅", heat: "65万", intro: "海岛灯塔守望者的日记，记录孤独、潮汐与多年后一次迟到的重逢。" },
];

export const comics = [
  { id: "c1", title: "墨绘江湖", genre: "热血", update: "更新至 186 话", cover: "https://readdy.ai/api/search-image?query=chinese%20wuxia%20comic%20cover%20art%20of%20a%20swordsman%20under%20bamboo%20in%20mist%2C%20ink%20brush%20style%2C%20gold%20and%20jade%20accents%2C%20dynamic%20composition%2C%20no%20text&width=600&height=900&seq=comic-jianghu-01&orientation=portrait" },
  { id: "c2", title: "猫咪事务所", genre: "治愈", update: "更新至 92 话", cover: "https://readdy.ai/api/search-image?query=cozy%20comic%20cover%20art%20of%20a%20tiny%20cat%20office%20with%20warm%20lamplight%20and%20plants%2C%20soft%20cream%20and%20amber%20palette%2C%20charming%20illustration%2C%20no%20text&width=600&height=900&seq=comic-cat-02&orientation=portrait" },
  { id: "c3", title: "机甲纪元", genre: "科幻", update: "更新至 240 话", cover: "https://readdy.ai/api/search-image?query=sci-fi%20mecha%20comic%20cover%20art%20of%20a%20giant%20robot%20over%20a%20neon%20ruined%20city%2C%20teal%20and%20amber%20lights%2C%20cinematic%20angle%2C%20no%20text&width=600&height=900&seq=comic-mecha-03&orientation=portrait" },
  { id: "c4", title: "校园小食光", genre: "青春", update: "更新至 64 话", cover: "https://readdy.ai/api/search-image?query=slice-of-life%20comic%20cover%20art%20of%20a%20sunny%20school%20canteen%20with%20friendly%20students%2C%20warm%20pastel%20and%20amber%20tones%2C%20cheerful%20illustration%2C%20no%20text&width=600&height=900&seq=comic-school-04&orientation=portrait" },
];

export const audiobooks = [
  { id: "a1", title: "论语新解", narrator: "周砚声", duration: "每集 22 分钟", episodes: "共 68 集", tag: "国学解读", intro: "以现代视角逐章讲解经典，通勤路上也能轻松听懂的思想入门。" },
  { id: "a2", title: "大江东去", narrator: "陈渡", duration: "每集 35 分钟", episodes: "共 120 集", tag: "历史长篇", intro: "一段跨越数十年的时代群像，真人播讲，声音质感沉稳，越听越上瘾。" },
  { id: "a3", title: "侦探笔记", narrator: "韩夜", duration: "每集 28 分钟", episodes: "共 86 集", tag: "悬疑推理", intro: "单元案件环环相扣，音效与旁白配合，夜深人静时听感格外沉浸。" },
  { id: "a4", title: "睡前童话集", narrator: "林晚", duration: "每集 12 分钟", episodes: "共 50 集", tag: "亲子共听", intro: "温柔女声讲述经典童话，音量平缓，适合睡前陪孩子安心入眠。" },
];

export const rankingTabs = [
  {
    key: "movie",
    label: "影视榜",
    items: [
      { rank: 1, title: "回声之城", meta: "科幻剧集 · 8.9 分", trend: "up" },
      { rank: 2, title: "夜航西飞", meta: "剧情电影 · 8.7 分", trend: "up" },
      { rank: 3, title: "山海奇谈", meta: "国风动画 · 8.6 分", trend: "same" },
      { rank: 4, title: "暗涌", meta: "悬疑剧集 · 8.5 分", trend: "down" },
      { rank: 5, title: "长风渡海", meta: "古装剧集 · 8.4 分", trend: "up" },
      { rank: 6, title: "无声告白", meta: "现实电影 · 8.3 分", trend: "same" },
    ],
  },
  {
    key: "novel",
    label: "小说榜",
    items: [
      { rank: 1, title: "九州云荒录", meta: "玄幻 · 连载中", trend: "up" },
      { rank: 2, title: "长夜将明", meta: "悬疑 · 已完结", trend: "same" },
      { rank: 3, title: "簪花录", meta: "古言 · 连载中", trend: "up" },
      { rank: 4, title: "星轨之下", meta: "科幻 · 已完结", trend: "down" },
      { rank: 5, title: "青衫误", meta: "都市 · 连载中", trend: "up" },
      { rank: 6, title: "雾中灯塔", meta: "现实 · 已完结", trend: "same" },
    ],
  },
  {
    key: "audio",
    label: "听书榜",
    items: [
      { rank: 1, title: "大江东去", meta: "历史长篇 · 120 集", trend: "up" },
      { rank: 2, title: "侦探笔记", meta: "悬疑推理 · 86 集", trend: "up" },
      { rank: 3, title: "论语新解", meta: "国学解读 · 68 集", trend: "same" },
      { rank: 4, title: "睡前童话集", meta: "亲子共听 · 50 集", trend: "down" },
      { rank: 5, title: "大江东去·番外", meta: "历史长篇 · 24 集", trend: "up" },
      { rank: 6, title: "深夜评书", meta: "曲艺评书 · 40 集", trend: "same" },
    ],
  },
];

export const comparison = {
  headers: ["对比项", "普通浏览", "无广告版体验"],
  rows: [
    { item: "页面广告", normal: "含少量推广位", clean: "页面清爽无推广位" },
    { item: "播放前贴片", normal: "偶有短贴片", clean: "直接进入正片" },
    { item: "阅读页干扰", normal: "存在浮动条", clean: "纯净阅读，无浮动打扰" },
    { item: "加载速度", normal: "常规加载", clean: "资源优先直出，更轻快" },
    { item: "资源更新", normal: "每日更新", clean: "每日更新，更新更快" },
    { item: "使用成本", normal: "免费", clean: "免费，无需额外费用" },
  ],
};

export const adFreeHighlights = [
  { icon: "ri-shield-star-line", title: "干净无扰", desc: "去掉页面推广与浮动条，观看与阅读都更专注。" },
  { icon: "ri-flashlight-line", title: "更轻更快", desc: "去掉冗余加载，剧集与章节打开速度更顺滑。" },
  { icon: "ri-device-line", title: "多端一致", desc: "手机、平板、电脑自适应布局，无广告体验一致。" },
  { icon: "ri-refresh-line", title: "持续更新", desc: "影视、小说、漫画与听书每日补充，内容不断档。" },
];

export const scenes = [
  { icon: "ri-subway-line", title: "通勤路上", desc: "戴上耳机听一段听书，或在手机上看两章爽文，路上时间不再无聊。" },
  { icon: "ri-moon-clear-line", title: "睡前时光", desc: "调低亮度看一集短剧，或打开睡前故事频道，安静地结束一天。" },
  { icon: "ri-cup-line", title: "午后小憩", desc: "配一杯咖啡翻几页漫画，十几分钟就能完成一次轻松的休息。" },
  { icon: "ri-home-smile-line", title: "周末宅家", desc: "挑一部口碑剧集连看几集，或把长篇小说一次追到最新章。" },
  { icon: "ri-run-line", title: "运动健身", desc: "听书频道支持后台播放与连续收听，跑步时双手也能空出来。" },
  { icon: "ri-parent-line", title: "亲子共听", desc: "挑选柔和音色的童话专辑，和孩子一起听故事，陪伴更轻松。" },
];

export const faqs = [
  {
    q: "这里的影视、小说和听书都是免费的吗？",
    a: "本站聚合的免费小说、漫画、听书与影视资源均可直接在线浏览，无需付费即可观看与阅读；无广告版同样是免费体验，只是提供更干净的浏览环境。",
  },
  {
    q: "使用前需要注册账号吗？",
    a: "浏览与检索资源无需注册即可进行。阅读进度、收听记录等个性化内容保存在本地设备上，刷新或更换设备后不一定会保留。",
  },
  {
    q: "如何获得更干净的观看体验？",
    a: "在页面顶部导航中切换到「无广告版」分区即可了解差异说明。无广告版会去掉页面推广位与浮动条，让观看和阅读更专注。",
  },
  {
    q: "资源更新频率是怎样的？",
    a: "影视剧集、小说章节、漫画话数与听书专辑均每日补充更新，热门作品会优先跟进最新进度，可在排行榜分区查看近期热度变化。",
  },
  {
    q: "支持哪些设备和浏览器？",
    a: "页面采用自适应布局，手机、平板与电脑浏览器都能顺畅浏览。手机端对竖屏漫画与听书播放做了专门适配，阅读与收听更方便。",
  },
  {
    q: "影视资源提供中文字幕吗？",
    a: "影视分区的一般条目均提供中文字幕，部分作品提供多清晰度选择。字幕类型与清晰度以页面展示的条目信息为准。",
  },
  {
    q: "页面上的检索会搜索全网吗？",
    a: "不会。检索与筛选仅作用于本页已收录的内容，用于在当前展示的影视、小说、漫画与听书条目中快速定位，不接入外部接口。",
  },
];

export const footerColumns = [
  {
    title: "内容板块",
    links: [
      { label: "中文在线高清影视", href: "#movies" },
      { label: "字幕免费小说", href: "#novels" },
      { label: "漫画免费看", href: "#library" },
      { label: "中文在线听书", href: "#audio" },
    ],
  },
  {
    title: "快速入口",
    links: [
      { label: "全站内容板块", href: "#categories" },
      { label: "在线检索", href: "#library" },
      { label: "热门榜单", href: "#ranking" },
      { label: "适用场景", href: "#scenes" },
    ],
  },
  {
    title: "体验与帮助",
    links: [
      { label: "无广告版体验", href: "#adfree" },
      { label: "常见问题", href: "#faq" },
      { label: "回到顶部", href: "#top" },
    ],
  },
];